module.exports = __webpack_public_path__ + "static/media/logo.4cf5f15f.png";